// The way into a park (ui/parkLoad.ts) for the React moments: the park office's answer on the menu,
// the round's screens arriving and the seat being taken. The DOM is built once per mount and told
// what changes; React never redraws it per frame.
import { useEffect, useRef } from 'react';
import { type ParkLoader, type ParkLoadInfo, parkLoading } from './parkLoad';

export function ParkLoading({ info, done }: { info: ParkLoadInfo; done: number }) {
  const host = useRef<HTMLDivElement>(null);
  const loader = useRef<ParkLoader | null>(null);
  useEffect(() => {
    const el = host.current;
    if (!el) return;
    const l = parkLoading({}, 'park');
    loader.current = l;
    el.append(l.el);
    return () => {
      l.stop();
      l.el.remove();
      loader.current = null;
    };
  }, []);
  // what the screen knows fills in as the park answers (one string, so a fresh object is no change)
  const key = JSON.stringify(info);
  useEffect(() => {
    loader.current?.set(JSON.parse(key) as ParkLoadInfo);
  }, [key]);
  useEffect(() => {
    loader.current?.reach(done);
  }, [done]);
  return <div className="pl-host" ref={host} />;
}
